var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6666 8.85221L12 12.0004M12 12.0004L6.33331 8.85221M12 12.0004L12 18.3337M18 14.7061V9.29468C18 9.06625 18 8.95204 17.9663 8.85017C17.9366 8.76005 17.8879 8.67733 17.8236 8.60754C17.7509 8.52865 17.651 8.47318 17.4514 8.36224L12.518 5.6215C12.329 5.51646 12.2344 5.46395 12.1343 5.44336C12.0457 5.42513 11.9543 5.42513 11.8657 5.44336C11.7656 5.46395 11.6711 5.51646 11.482 5.6215L6.54865 8.36225C6.34896 8.47318 6.24912 8.52865 6.17642 8.60754C6.11211 8.67733 6.06343 8.76005 6.03366 8.85017C6 8.95204 6 9.06625 6 9.29468V14.7061C6 14.9345 6 15.0487 6.03366 15.1506C6.06343 15.2407 6.11211 15.3234 6.17642 15.3932C6.24912 15.4721 6.34897 15.5276 6.54865 15.6385L11.482 18.3793C11.6711 18.4843 11.7656 18.5368 11.8657 18.5574C11.9543 18.5756 12.0457 18.5756 12.1343 18.5574C12.2344 18.5368 12.329 18.4843 12.518 18.3793L17.4514 15.6385C17.651 15.5276 17.7509 15.4721 17.8236 15.3932C17.8879 15.3234 17.9366 15.2407 17.9663 15.1506C18 15.0487 18 14.9345 18 14.7061Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/default_icon.b0f11c6764ce2a44dd926c7263ba6cb2.svg";
export { ForwardRef as ReactComponent };